import { HttpHeaders, HttpParams } from "@angular/common/http";

export class HttpMethodArgs {
    constructor(
        public methodType: string,
        public apiEndpoint: string,
        public resultType: string,
        public body?: any,
        public extraData?: any,
        public httpParam?: HttpParams,
        public httpHeader?: HttpHeaders
    ){}
}
